import { ALERT, LOADING_BAR, STORE_BRAND, STORE_LANGUAGE, STORE_MOBILE_VERSION_ACTION } from '../constants/action-types'

export function isLoading(loading) {
  return { type: LOADING_BAR, loading }
}

export function showAlert(fail, success, code, errorMessage) {
  return {
    type: ALERT,
    showFail: fail,
    showSuccess: success,
    code,
    errorMessage,
  }
}

export const storeMobileVersionActionCreator = (mobileVersion) => {
  return { type: STORE_MOBILE_VERSION_ACTION, mobileVersion }
}

export const storeSelectedLanguageActionCreator = (language) => {
  return { type: STORE_LANGUAGE, language }
}

export const storeBrandActionCreator = (brand) => {
  return { type: STORE_BRAND, brand }
}
